const isDev = process.env.NODE_ENV === 'development'

const config = {
  'development': {
    'ARTICLE_API': 'https://mainssl.geekpark.net/api/v1'
  },
  'production': {
    'ARTICLE_API': 'https://mainssl.geekpark.net/api/v1'
  }
}

export default isDev ? config['development'] : config['production']



// WEBPACK FOOTER //
// ./src/config.js